<template>
  <div style="margin-top: 5px">
    <el-col :span="1.5">
      <el-upload
        ref="upload"
        style="margin-right: 10px"
        class="upload-demo"
        :action="sys_app_logoAction"
        accept="xlsx"
        :limit="1"
        :on-success="(res)=>{return importUploadSuccess(res)}"
        :headers="headers"
      >
        <el-button :v-permisaction="[importP]" icon="el-icon-upload2" size="mini" type="primary">{{ importTitle }}</el-button>
      </el-upload>
    </el-col>

    <el-col :span="1.5">
      <el-button
        :v-permisaction="[exportP]"
        type="primary"
        icon="el-icon-download"
        size="mini"
        @click="exportData()"
      >{{ exportTitle }}</el-button>
    </el-col>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'
export default {
  name: 'CommonExport',
  props: {
    importTitle: {
      type: String,
      default: '导入'
    },
    exportTitle: {
      type: String,
      default: '导出'
    },
    importMethod: {
      type: Function,
      required: true
    },
    exportMethod: {
      type: Function,
      required: true
    },
    getTable: {
      type: Function,
      required: true
    },
    importP: {
      type: String,
      required: false,
      default: ''
    },
    exportP: {
      type: String,
      required: false,
      default: ''
    },
    id: {
      type: String,
      required: false,
      default: ''
    },
    type: {
      type: String,
      required: false,
      default: ''
    }

  },
  data() {
    return {
      loading: false,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile'
    }
  },
  methods: {
    importUploadSuccess(response) {
      this.loading = true
      this.$refs.upload.clearFiles()
      this.importMethod({ data: response.data.path, id: this.id, type: this.type }).then(res => {
        // eslint-disable-next-line eqeqeq
        this.loading = false
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTable()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData() {
      this.exportMethod({ id: this.id }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
